const rad = (d) => {
  return d * Math.PI / 180.0;
}

/**
 * 获取当前位置与目录位置的距离
 * @param {用户当前纬度} lat1
 * @param {用户当前经度} lng1
 * @param {目标位置纬度} lat2
 * @param {目标位置经度} lng2
 */
const Distance = (lat1, lng1, lat2, lng2)=>{
  if(!lat1 || !lat2){
    return ''
  }
  var radLat1 = rad(lat1);
  var radLat2 = rad(lat2);
  var a = radLat1 - radLat2;
  var b = rad(lng1) - rad(lng2);
  var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
    Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
  s = s * 6378.137; // EARTH_RADIUS;
  //输出为公里
  s = Math.round(s * 10000) / 10000;  
  var distance = s;
  var distance_str = "";
  if (parseInt(distance) >= 1) {
    distance_str = distance.toFixed(1) + "KM";
  } else {
    distance_str = distance.toFixed(3) * 1000 + "M";
  }
  return distance_str;
}
const formData = (times)=>{
  if (times<60){
    if (times<10){
      return "00:0"+times
    }
    return "00:"+times
  }
  if(times>=60){
    // 获取分钟数
    let minute = parseInt(times / 60);
    if (minute<10){
      minute = "0" + minute
    }else{
      minute = minute
    }
    // 获取秒数
    let second = parseInt(times % 60);
    if (second<10){
      second = "0" + second
    }else{
      second = second
    }
    // 拼接分秒
    return minute + ":" + second
  }
}
const formatlat = (location)=>{
  if(!location) return;
  let coordinate = location.split(",");
  coordinate.sort((a,b)=>{return a-b});
  let latitude =parseFloat(coordinate[0]);
  let longitude = parseFloat(coordinate[1]);
  let latlng = [longitude,latitude];
  return latlng;
}

module.exports = {
  Distance,
  formData: formData,
  formatlat,
}